import { Component, OnInit } from "@angular/core";
import { NotificationsService } from "src/app/Services/shared/notifications.service";
import { NgxSpinnerService } from "ngx-spinner";
import { SystemSettingService } from "src/app/Services/system-setting.service";
import { saveSystemSettingRequest, SystemSettings } from "src/app/models/systemsetting.model";
import { NotificationTypes } from "src/app/app.enums";
import { AuthService, ResponseObject } from "src/app/Services/auth.service";
import { TranslocoService } from "@jsverse/transloco";

@Component({
    selector: 'system-settings',
    templateUrl: './system-settings.component.html',
    styleUrls: ['./system-settings.component.css'],
    standalone: false
})

export class SystemSettingsComponent implements OnInit{
    public systemSettings!: SystemSettings;
    public systemSettingsDataLoaded: boolean = false;
    public systemSettingFormData!: saveSystemSettingRequest;
    public systemSettingsDailogVisible: boolean = false;

    constructor(private systemSettingService:SystemSettingService,private ngxSpinnerService:NgxSpinnerService,private notificationsService:NotificationsService,private transloco:TranslocoService){
        this.systemSettingFormData = new saveSystemSettingRequest();
    }   
    ngOnInit(): void {
        this.getSystemSettings();
    }

    public getSystemSettings(){
        this.ngxSpinnerService.show();
        this.systemSettingService.fetchAllSystemSettings().subscribe((SystemSettingsApiResponce: SystemSettings)=>{
            this.systemSettings = SystemSettingsApiResponce
            console.log(this.systemSettings)
            this.ngxSpinnerService.hide()
            this.systemSettingsDataLoaded = true
        }, (error) => { console.error('Error while fetching system settings data', error); this.ngxSpinnerService.hide(); })
    }

    public onSaveSystemSettings(){
        console.log(this.systemSettingFormData)
        this.ngxSpinnerService.show();
        this.systemSettingService.saveSystemSettings(this.systemSettingFormData).subscribe((response: ResponseObject) => {
        this.ngxSpinnerService.hide();
        if (response.Success) {
            this.notificationsService.showNotification(this.transloco.translate('systemSettings.successTitle'), response.ResponseMessage, NotificationTypes.Success);
            this.closeDialog();
            this.getSystemSettings()
        }
        else {
            this.notificationsService.showNotification(this.transloco.translate('systemSettings.errorTitle'), response.ResponseMessage, NotificationTypes.Error);
        }
        },(error) => {console.error(error);this.ngxSpinnerService.hide();});
    }
    
    public onShowSystemSettingDailog(systemSettingsData: SystemSettings | null){
        if (systemSettingsData) {
            this.systemSettingFormData = this.mapSubscriptionRuleData(systemSettingsData);
            this.systemSettingsDailogVisible = true;
        }
    }

    private mapSubscriptionRuleData(subscriptionRuleData: SystemSettings): saveSystemSettingRequest {
        return {
            freeTrialPeriodDays: subscriptionRuleData.FreeTrialPeriodDays,
            // freeTrialPeriodMinutes: subscriptionRuleData.FreeTrialPeriodMinutes
        };
    }


    public closeDialog(){
        this.systemSettingsDailogVisible = false;
    }

    public preventNegativeValues(event: any): void {
        let value = event.target.value;
          value = value.replace(/-/g, '');
          // Allow only valid decimal numbers (positive values with an optional decimal point)
          const regex = /^[0-9]*\.?[0-9]*$/;
      
          if (!regex.test(value)) {
              // If invalid, revert to previous valid value or set to empty string
              this.systemSettingFormData.freeTrialPeriodDays = 0;
          } else {
              // Ensure value remains a valid positive decimal number
              this.systemSettingFormData.freeTrialPeriodDays = value;
          }
        if (event.target.value < 0) {
          // event.target.value = 0;
          this.systemSettingFormData.freeTrialPeriodDays = 0
        }
    }


}